<template>
  <div class="Site IndexBox" style="padding-top: 48px">
    <van-nav-bar fixed :border="false" :title="$t('task.default[0]')" left-arrow @click-left="$router.go(-1)" />
    <div class="ScrollBox">
      <van-tabs :ellipsis="false" :border="false" color="#37774C" background="#fff" title-active-color="#37774C" title-inactive-color="#bbb" line-width="60" v-model="tabsIndex" @change="changeTabs">
        <van-tab v-for="item in taskTabs" :title="item.text" :key="item.state">
        <van-pull-refresh  v-model="isRefresh" @refresh="onRefresh" style="">
          <van-list v-model="isLoad" :finished="isFinished"
            :finished-text="listData[tabsIndex].length ? $t('vanPull[0]') : $t('vanPull[1]')" @load="onLoad"
            :class="{ Empty: !listData[tabsIndex].length }">
            <div v-if="tabsIndex == 0">
               <div v-if="msg" style="margin-top:50%;margin-left:5%;" v-html="msg"></div>
               <div v-else v-for="(item, index) in listData[tabsIndex]">
                  <div v-if="index>=(UserInfo.number-UserInfo.task_wc_num) || is_expired==1" style="position: absolute; padding: 0 10px 0 10px;height: 110px;width: 100%;z-index: 999;">
                    <div class="item-task-mock">
                      <img :src="`./static/images/home/lock@2x.png`" style="width:59px;height:59px;margin:20px 20px 0 20px;"/>
                      <div>
                        <p style="padding:10px 0; color:#333;">{{$t('home.title[4]')}}</p>
                        <van-button round type="info" @click="toVip" color="#37774C" style="height: 30px;width:70%;left:50%;transform: translateX(-50%);"
                          block>{{$t('home.title[3]')}}</van-button>
                      </div>
                    </div>
                  </div>
                  <van-cell class="TaskItem" title-class="record" :border="false"
                  :key="item.order_id" @click="goPost(item.order_id)" >
                  <template #icon>
                    <img :src="item.link_info" style="height: 4.1rem;width: 4rem;border-radius:15px;" />
                  </template>
                  <template #title>
                    <div style="color:black;">{{ item.title }}</div>
                    <div style="color:black;">{{ item.reward_price }}{{ InitData.currency }}</div>
                    <div style="color:black;height:20px;">{{ item.code }}</div>
                    <van-button v-if="item.order_id==0" type="info" color="#37774C" style="width: 190px;height: 30px;" block @click="onReceiveTask(item.task_id)">{{$t('task.default[9]')}}</van-button>
                    <van-button v-if="item.order_id>0 && item.status==1" type="info" color="#37774C" style="width: 190px;height: 30px;" block disabled>{{$t('task.default[10]')}}</van-button>
                  </template>
                </van-cell>
              </div>
            </div>
            <div v-else>
              <div v-for="(item, index) in listData[tabsIndex]">
                <van-cell class="TaskItem" title-class="record" :border="false" v-for="(item, index) in listData[tabsIndex]"
                  :key="item.order_id">
                  <template #icon>
                    <img :src="item.link_info" style="height: 5rem;width: 5rem;border-radius:15px;" />
                  </template>
                  <template #title>
                    <div style="color:black;">{{ item.title }}</div>
                    <div style="color:black;">{{ item.reward_price }}{{ InitData.currency }}</div>
                    <div style="color:black;">{{ item.trial_time }}</div>
                  </template>
                  <!-- <div class="state">
                    <p>
                      <img :src="`./static/images/state${item.status}.png`" height="50">
                    </p>
                  </div> -->
                </van-cell>
              </div>
            </div>

          </van-list>
        </van-pull-refresh>
      </van-tab>
      </van-tabs>
    </div>
    <Footer />
  </div>
</template>

<script>
export default {
  name: 'TaskRecord',
  components: {
  },
  props: ['taskState'],
  data() {
    return {
      listData: '',
      isLoad: false,
      isFinished: false,
      isRefresh: false,
      pageNo: 1,
      tabsState: 1,
      tabsIndex: 0,
      taskTabs: [
        { state: 1, text: this.$t('task.tabs[0]') },
        //{ state: 2, text: this.$t('task.tabs[1]') },
        { state: 3, text: this.$t('task.tabs[2]') }
      ],
      fileList: [],
      show: false,
      time: 20000,
      isTime: true,
      currencyId: '',
      currencyIndex: -1,
      currencyUrl: '',
      task_id: 0,
      isTask: 0,
      msg:'',
      is_expired:0,
    }
  },
  computed: {

  },
  watch: {

  },
  created() {
    this.listData = this.taskTabs.flatMap(item => [''])
    this.getListData('init')
  },
  mounted() {

  },
  activated() {

  },
  destroyed() {

  },
  methods: {
    onReceiveTask(id) {
      this.$Model.ReceiveTask(id, data => {
        if(data.code==1){
          this.$router.push(`/taskShow/${data.new_id}`);
        } else {
          this.$Dialog.Alert(data.code_dec);
        }
        //this.$Dialog.Toast(data.code_dec);
        //this.getListData('init');
      })
    },
    onLoad() {
      this.getListData('load')
    },
    changeTabs(index) {
      this.tabsState = this.taskTabs[index].state
      //console.log(this.tabsState)
       this.getListData('init')
    },
    getListData(type) {
      this.isLoad = true
      this.isRefresh = false
      console.log(type);
      if (type == 'load') {
        this.pageNo += 1
      } else {
        this.pageNo = 1
      }
      this.$Model.GetTaskRecord({ status: this.tabsState, page_no: this.pageNo, is_u: 2 }, data => {
        this.isLoad = false
        this.isTask = data.task
        this.is_expired = data.is_expired
        // this.isFinished = true
        if (data.code == 1) {
          if (type == 'load') {
            this.listData[this.tabsIndex] = this.listData[this.tabsIndex].concat(data.info);
          } else {
            this.listData[this.tabsIndex] = data.info
          }
          if (data.info.length<1) {
            this.isFinished = true
          } else {
           this.isFinished = false
          }
          this.msg = '';
        }else if(data.code == 2) {
          this.listData[this.tabsIndex] = '';
          this.isFinished = true;
          this.msg = data.code_dec;
        } else {
          this.listData[this.tabsIndex] = '';
          this.isFinished = true;
          this.msg = '';
        }
        
      })
    },
    onRefresh() {
      this.getListData('init')
    },
    afterRead(file) {
      file.status = 'uploading'
      file.message = this.$t('upload[0]')
      this.uploadImgs(file)
    },
    toVip() {
      this.$router.push(`/T`);
    },
    compressImg(file) {
      this.$Util.CompressImg(file.file.type, file.content, 750, (image) => {
        let param = new FormData();
        param.append('token', localStorage['Token']);
        param.append('type', 3);
        param.append('image', image, file.file.name);
        this.$Model.UploadImg(param, (data) => {
          if (data.code == 1) {
            file.message = this.$t('upload[2]')
            file.status = 'success'
            file.url = data.url
          } else {
            file.status = 'failed'
            file.message = this.$t('upload[3]')
          }
        });
      })
    },
    uploadImgs(file) {
      if (file.length) {
        file.forEach(item => {
          if (!item.file.type.match(/image/)) {
            item.status = 'failed'
            item.message = this.$t('upload[1]')
            return;
          }
          this.compressImg(item)
        })
      } else {
        if (!file.file.type.match(/image/)) {
          file.status = 'failed'
          file.message = this.$t('upload[1]')
          return;
        }
        this.compressImg(file)
      }
    },
    submitTask(id, index) {
      if (id > 0) {
        this.$Model.SubmitTask({ order_id: id }, data => {
          if (data.code == 1) {
            this.$Dialog.Toast(this.$t('task.msgSc'));
            this.getListData('init')
          }
        })
      }
    },
    cancelTask(id, index) {
      this.$Model.SubmitTask({ order_id: id, status: 6 }, data => {
        if (data.code == 1) {
          this.getListData('init')
        }
      })
    },
    onShowDetail(id, index, url, task_id) {
      if (this.isTask == 0) {
        /* this.$Model.ReceiveTask(task_id,data=>{
            if(data.code==1){
              this.isTime = true
              this.show = true
              this.currencyId=data.id
              this.currencyIndex = index
              this.currencyUrl = url
            } else { */
        this.isTime = true;
        this.show = true;
        this.currencyId = 0;
        this.currencyIndex = index;
        this.currencyUrl = url;
        this.task_id = task_id;
        //}
        //})
      } else {
        this.$Dialog.Toast(this.$t('task.msg'));
      }
    },
    onCloseDetail() {
      console.log('closeTime')
      this.isTime = false
      this.show = false
      this.currencyId = ''
      this.currencyIndex = -1
      this.currencyId = ''
    },
    goPost(id) {
      if(id > 0) {
        this.$router.push(`/taskShow/${id}`);
      }
      
    },
  }
}
</script>
<style lang="scss"  scoped>
.ScrollBox {
  background-color: fff;
}

.van-tabs ::v-deep .van-tab {
  padding: 0 10px;
}

.Site ::v-deep .van-tabbar {
  background-color: #fff;
}

/* .Site ::v-deep .van-tabbar-item__text {
  color: #000;
} */

.van-uploader {
  display: block;
  margin-top: 10px;
}

.van-uploader ::v-deep .van-uploader__upload-icon {
  opacity: .3;
  font-size: 16px;
}

.van-uploader ::v-deep .van-uploader__wrapper {
  justify-content: flex-end;
  flex-direction: column;
  align-items: flex-end;
}

.van-uploader ::v-deep .van-uploader__upload,
.van-uploader ::v-deep .van-uploader__preview-image {
  width: 36px;
  height: 36px;
  margin-right: 0;
  background-color: #0b273f;
}

.van-uploader ::v-deep .van-uploader__preview {
  margin-right: 0;
}

.van-uploader ::v-deep .van-uploader__mask-message {
  white-space: nowrap;
}

.van-pull-refresh {
  min-height: calc(100vh - 90px);
}

.TaskItem {
  margin-bottom: 10px;
  border-radius: 0px;
  box-shadow: 0 .01rem 0.06rem rgba(0, 0, 0, .2)
}

.TaskItem .van-cell__value {
  overflow: visible;
}

.van-list {
  overflow: hidden;
  margin-top: 10px;
  padding-top: 10px;
}

::v-deep .van-nav-bar__content {
  background: linear-gradient(to right,$theme-shallow-color, $theme-color);
  color: #fff;
}
::v-deep .van-nav-bar__title {
  color: #fff;
}
::v-deep .van-nav-bar .van-icon {
  color: #fff !important;
}

.item-task-mock{
  width: 100%;
  height: 125px;
  background: rgba(51,51,51,0.55);
  // border-radius: 10px 10px 10px 10px;
  display:flex;
  background: rgba(255, 255, 255, 0.1); /* ��͸����ɫ */
  backdrop-filter: blur(5px) saturate(150%); /* ģ��+���Ͷ���ǿ */
  -webkit-backdrop-filter: blur(5px) saturate(150%);
}
.item-task-mock ::v-deep .van-button--info{
    border: 3px solid #fff !important;
  }
</style>